export default __webpack_public_path__ + "static/media/telegram.684cbd76.png";